/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FolderIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FolderIcon({
  children,
  viewPath = "/DesignSystem/Svgs/FolderIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="FolderIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-1n8Web': alignSelf,'--mt-2-1n8Web': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1n8Web': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1n8Web': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1n8Web': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1n8Web': opacity,'--w-10-1n8Web': typeof width === 'number' ? `${width}px` : width,'--h-11-1n8Web': typeof height === 'number' ? `${height}px` : height,'--a-7-1n8Web': isAnimated ? animation : "none",'--sd-8-1n8Web': isAnimated ? strokeDashoffset : 0,'--sd-9-1n8Web': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="FolderIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M29.3 27.1H2.7V4.9H16l1.9 5.1h11.4z"
 style={{'--f-12-1n8Web': fill,'--s-13-1n8Web': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}